<template>
  <div class="header-search">
    <div class="main clearfix w">
      <div class="header-search-fl fl">
        <a href="/">
          <img
            class="imgs"
            src="@/assets/images/home/logo111.png"
            alt=""
            width="148px"
          />
        </a>
      </div>
      <!-- 搜索框 -->
      <div class="header-search-fr fl" id="haertop">
        <div class="header-search-fr-btn">
          <!-- 配件查询 -->
          <!-- <div :class="{ active: this.active === 'partsSearch' }">
            <router-link
              rel="opener"
              :to="{
                path: '/partsSearch',
                query: {
                  searchContent: this.searchContent
                }
              }"
            >
              <i :class="{ clickI: searchFlag == 1 }">配件查询 &nbsp;</i>
              <span class="huise">|&nbsp;</span>
            </router-link>
          </div> -->
          <!-- 店铺查询 -->
          <!-- <div :class="{ active: this.active === 'storeSearch' }">
            <router-link
              rel="opener"
              :to="{
                path: '/storeSearch',
                query: {
                  storeSearch: this.storeSearch
                }
              }"
            >
              <i :class="{ clickI: searchFlag == 2 }">店铺查询</i>
              <span class="huise">&nbsp;&nbsp;|&nbsp;</span>
            </router-link>
          </div> -->
          <!-- vin码查询 -->
          <!-- <div :class="{ active: this.active === 'VINSearch' }">
            <router-link
              rel="opener"
              :to="{
                path: '/VINSearch',
                query: {
                  VINSearch: this.VINSearch
                }
              }"
            >
              <i :class="{ clickI: searchFlag == 3 }">VIN码查询</i>
            </router-link>
          </div> -->

          <!-- 配件查询 -->
          <div>
            <a>
              <i :class="{ clickI: searchFlag == 1 }" @click="changeSch(1)"
                >{{ $t('home.Accessories') }} &nbsp;</i
              >
              <span class="huise">|&nbsp;</span>
            </a>
          </div>
          <!-- 店铺查询 -->
          <div>
            <a>
              <i :class="{ clickI: searchFlag == 2 }" @click="changeSch(2)"
                >{{ $t('home.store') }}</i
              >
              <span class="huise">&nbsp;&nbsp;|&nbsp;</span>
            </a>
          </div>
          <!-- vin码查询 -->
          <div>
            <a>
              <i :class="{ clickI: searchFlag == 3 }" @click="changeSch(3)"
                >{{ $t('home.VIN') }}</i
              >
            </a>
          </div>
        </div>
        <!-- 输入框 -->
        <div
          class="search-box fl flex"
          v-show="searchFlag == 1"
          style="position: relative"
        >
          <Input
            v-show="!isArr"
            id="aaa"
            v-model.trim="searchContent"
            type="text"
            @keyup.enter.native="enterBtn"
            :placeholder="$t('home.placeholder3')"
            @on-focus="focusBtn(1)"
            @on-blur="blurBtn(1)"
            @paste.native="pasting"
          />
          <textarea
            type="text"
            ref="focusTextarea"
            autofocus="autofocus"
            @focus.prevent="focusTxt()"
            @blur.prevent="blurBtn(1)"
            @keydown.enter="keyEnter"
            v-focus="statefocus"
            class="w13"
            id="txt"
            v-show="isArr"
            autocomplete="off"
            :placeholder="$t('home.placeholder3')"
          >
          </textarea>
          <Icon
            type="md-close"
            @click="delarr()"
            class="w2"
            v-show="isArr"
            size="21"
          />
          <Button class="btn search-btn felx1" @click="onSearch(1)" id="btn">
            <i class="iconfont icon-sousuo"></i>
            <span class="fz16 seek">{{ $t('home.search') }}</span></Button
          >
        </div>
        <!-- 店铺搜索 -->
        <div class="search-box fl flex" v-show="searchFlag == 2">
          <Input
            v-model.trim="storeSearch"
            type="text"
            :placeholder="$t('home.placeholder1')"
            @on-focus="focusBtn(2)"
            @on-blur="blurBtn(2)"
          />
          <Button class="btn search-btn felx1" @click="onSearch(2)">
            <i class="iconfont icon-sousuo"></i>
            <span class="fz16">{{ $t('home.search') }}</span>
          </Button>
        </div>
        <!-- VIN码查询 -->
        <div class="search-box fl flex" v-show="searchFlag == 3">
          <Input
            v-model="VINSearch"
            type="text"
            :placeholder="$t('home.placeholder2')"
            @on-focus="focusBtn(3)"
            @on-blur="blurBtn(3)"
          />
          <Button class="btn search-btn felx1" @click="onSearch(3)">
            <i class="iconfont icon-sousuo"></i>
            <span class="fz16">{{ $t('home.search') }}</span>
          </Button>
        </div>
        <!-- 历史记录 -->
        <div class="w1" v-show="isHistory">
          <p v-for="item in historyList" :key="item.id">
            <span @mousedown="checkP(item)">{{ item.keyword }}</span>
            <Icon
              type="md-close"
              size="12"
              @mousedown.native="delHistory(item)"
            />
          </p>
        </div>
      </div>
<!--      <div class="header-search-fl1 fr">-->
<!--        <a href="/" style="padding-left: 10px">-->
<!--          <img class="imgs2" src="@/assets/images/home/28-logo.png" alt=""-->
<!--        /></a>-->
<!--      </div>-->
    </div>
    <!-- tab栏 -->
<!--    <div class="tabs w">-->
<!--      <ul class="clearfix">-->
<!--        <li :class="{ active: this.activeName === 'home' }">-->
<!--          <router-link rel="opener" :to="{ path: '/' }">-->
<!--            <i>首页</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li :class="{ active: this.activeName === 'supportself' }">-->
<!--          <router-link rel="opener" :to="{ path: '/supportself' }">-->
<!--            <i>自营专区</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li :class="{ active: this.activeName === 'activity' }">-->
<!--          <router-link rel="opener" :to="{ path: '/activity' }">-->
<!--            <i>自营活动</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li-->
<!--          v-if="holder"-->
<!--          :class="{ active: this.activeName === 'shareholder' }"-->
<!--        >-->
<!--          <router-link rel="opener" :to="{ path: '/shareholder' }">-->
<!--            <i>股东联盟</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li v-if="League" :class="{ active: this.activeName === 'JPremit' }">-->
<!--          <router-link rel="opener" :to="{ path: '/JPremit' }" target="_blank">-->
<!--            <i>极配汇</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        &lt;!&ndash; <li :class="{ active: this.activeName === 'partsNavigation' }">-->
<!--          <router-link-->
<!--            rel="opener"-->
<!--            :to="{-->
<!--              path: '/partsNavigation',-->
<!--              query: { obj: JSON.stringify(this.ids) }-->
<!--            }"-->
<!--          >-->
<!--            <i>车型查询</i>-->
<!--          </router-link>-->
<!--        </li> &ndash;&gt;-->
<!--        &lt;!&ndash; <li>-->
<!--          <router-link rel="opener" :to="{ path: '/mingjue' }" target="_blank">-->
<!--            <i>电子目录</i>-->
<!--          </router-link>-->
<!--        </li> &ndash;&gt;-->
<!--        <li>-->
<!--          <router-link-->
<!--            rel="opener"-->
<!--            :to="{ path: '/catalogue' }"-->
<!--            target="_blank"-->
<!--          >-->
<!--            <i>电子目录</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>

<script defer=true>
import lottie from 'lottie-web'
import gif1 from '@/assets/images/data.json'
import { history, delhistory } from '@/api/headerSearch.js'
export default {
  name: 'header-search',
  data() {
    return {
      statefocus: false,
      value: '',
      isShowhistory: 1,
      area: '', // 判断哪种历史记录
      isHistory: false,
      // height: '100px',
      arr: [],
      isArr: false,
      ids: {
        a: '666'
      },
      // gif1Control: {},
      holder: true,
      League: true, // 判断卖家登录是否看到极配汇
      storeSearch: this.$route.query.storeSearch || '',
      VINSearch: this.$route.query.VINSearch || '',
      // selected: true,
      searchFlag: 1,
      isUser: this.$store.state.user.userData,
      searchContent: this.$route.query.searchContent || '', //搜索框内容,
      historyList: []
    }
  },
  props: {
    activeName: {
      type: String
    },
    active: {
      type: String
    },
    flag: {
      type: Number
    }
  },
  created() {
    // console.log(this)
    this.searchFlag = this.flag
    this.getImg()
    if (!localStorage.getItem('userData')) {
      this.holder = true
      this.League = true
    } else {
      this.holder =
        JSON.parse(localStorage.getItem('userdetails_leagueInfo'))
          .hasShareHolder == 0
          ? false
          : true
      this.League =
        JSON.parse(localStorage.getItem('userdetails_leagueInfo'))
          .isQuickWearPartLeague == 0
          ? false
          : true
    }
  },
  methods: {
    getImg() {
      this.$nextTick(async () => {
        var params1 = {
          container: document.getElementById('lottile'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: gif1
        }
        lottie.loadAnimation(params1)
      })
    },
    // 搜索
    onSearch(i) {
      if (i == 1) {
        if (this.isArr) {
          this.searchContent = document.getElementById('txt').value
        }
        if (this.searchContent == '') {
          this.$Message.destroy()
          this.$Message.warning(
            '请输入配件编码/配件名称(多配件查询用半角逗号分隔)'
          )
        } else {
          console.log(this.searchContent)
          let arr = this.searchContent.split(/[(\r\n)\r\n]+/)
          console.log(arr)
          if (arr.length > 1) {
            if (arr.length > 10) {
              // this.$Message.destroy()
              // this.$Message.warning('单次搜索数量不得大于10个。')
              arr = arr.slice(0, 10)
            }
          }
          let data = arr.join(',')
          this.searchContent = data
          this.$router.push({
            path: '/partsSearch',
            query: {
              searchContent: this.searchContent,
              searchFlag: 1,
              current: Number(1),
              size: Number(10)
            }
          })
          this.$emit('getDataListSearch')
        }
      } else if (i == 2) {
        if (this.storeSearch == '') {
          this.$Message.warning('请输入店铺名称')
        } else {
          this.$router.push({
            path: '/storeSearch',
            query: {
              storeSearch: this.storeSearch,
              searchFlag: 2
            }
          })
          this.$emit('getlistShop')
        }
      } else {
        const key = JSON.parse(JSON.stringify(this.VINSearch))
        const list = key.replace(/[, ]/g, '')
        let len = 0
        for (let i = 0; i < list.length; i++) {
          if (list.charCodeAt(i) > 127 || list.charCodeAt(i) == 94) {
            len += 2
          } else {
            len++
          }
        }
        if (len == 17) {
          this.$router.push({
            path: '/VINSearch',
            query: {
              VINSearch: this.VINSearch,
              searchFlag: 3
            }
          })
          this.$emit('getDataList',3)
        } else {
          this.$Message.destroy()
          this.$Message.warning('请输入17位VIN码')
        }
      }
    },
    // 切换搜索方式
    changeSch(i) {
      this.historyList = []
      this.searchFlag = i
      if (this.isArr) {
        if (i == 1) {
          document.getElementById('haertop').style.paddingTop = '49px'
          document.getElementById('btn').style.height = '60px'
        } else if (i == 2 || i == 3) {
          document.getElementById('haertop').style.paddingTop = '73px'
          document.getElementById('btn').style.height = '36px'
        }
      } else {
      }
      this.isHistory = false
    },
    // 输入框聚焦触发历史记录
    async focusBtn(i) {
      // this.isShowhistory = 0
      // let area = ''
      if (i == 1) {
        this.area = 1
      } else if (i == 2) {
        this.area = 10
      } else if (i == 3) {
        this.area = 6
      }
      // console.log(i, area)
      const res = await history({
        area: this.area,
        size: 10
      })
      console.log(res)
      if (res.status) {
        if (res.data.length) {
          this.historyList = res.data
          this.isHistory = true
        } else {
          this.isHistory = false
        }
      }
      // console.log();
    },
    // 失焦触发
    blurBtn() {
      this.isHistory = false
    },
    // 选中某条历史记录
    checkP(item) {
      console.log(item)
      let i = ''
      document.getElementById('txt').value = ''
      document.getElementById('haertop').style.paddingTop = '73px'
      document.getElementById('btn').style.height = '36px'
      this.isArr = false
      console.log(this.area)
      if (this.area == 1) {
        this.searchContent = item.keyword
        i = 1
      } else if (this.area == 10) {
        this.storeSearch = item.keyword
        i = 2
      } else if (this.area == 6) {
        i = 3
        this.VINSearch = item.keyword
      }
      this.onSearch(i)
    },
    // 删除历史记录
    async delHistory(item) {
      // this.isHistory = true
      console.log(item, '5555')
      const res = await delhistory({ id: item.id })
      console.log(res)
      if (res.status) {
        let i = ''
        if (this.area == 1) {
          // this.searchContent = item.keyword
          i = 1
        } else if (this.area == 10) {
          // this.storeSearch = item.keyword
          i = 2
        } else if (this.area == 6) {
          i = 3
          // this.VINSearch = item.keyword
        }
        this.focusBtn(i)
      }
    },
    // 监听输入框粘贴事件
    pasting(e) {
      console.log(e)
      var clip = e.clipboardData.getData('Text')
      console.log(clip)
      if (/\n/g.test(clip)) {
        // let arr = this.searchContent.split(/\s+/)
        this.searchContent = clip
        this.changeBtn()
      }
      // console.log(this.searchContent)
      // console.log(typeof clip)
    },
    // 监听输入框粘贴事件
    changeBtn() {
      console.log(this.searchContent)
      let arr = this.searchContent.split(/[(\r\n)\r\n]+/)
      console.log(arr)
      arr.forEach((item, index) => {
        if (!item) {
          arr.splice(index, 1)
        }
      })
      if (arr.length > 1) {
        if (arr.length > 10) {
          this.$Message.destroy()
          this.$Message.warning('单次搜索数量不得大于10个。')
          arr = arr.slice(0, 10)
        }
        let data = JSON.parse(JSON.stringify(arr))
        let data1 = data.join(',')
        let data2 = data1.replaceAll(',', '\n')
        this.isArr = true
        this.$nextTick(() => {
          document.getElementById('txt').value = data2
        })
        this.arr = arr
        document.getElementById('haertop').style.paddingTop = '49px'
        document.getElementById('btn').style.height = '60px'
      }
    },
    // 删除文本框搜索
    delarr() {
      // console.log(item)
      // this.arr = []
      // arr.push('')
      this.searchContent = ''
      document.getElementById('txt').value = ''
      this.isArr = false
      // this.arr = this.arr.filter((i) => {
      //   return item != i
      // })
      // if (this.arr.length == 0) {
      //   this.isArr = false
      document.getElementById('haertop').style.paddingTop = '73px'
      document.getElementById('btn').style.height = '36px'
      //   this.searchContent = ''
      // }
      // console.log(this.arr)
    },
    // 监听text文本框enter事件
    keyEnter(event) {
      console.log(event)
      event = event ? event : window.event ? window.event : ''
      var keyCode = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode
      if (event.keyCode == 13 && event.ctrlKey) {
        //ctrl+enter换行
        document.getElementById('txt').value =
          document.getElementById('txt').value + '\n' // 获取textarea数据进行 换行
        this.searchContent = document.getElementById('txt').value
      } else if (keyCode == 13) {
        event.preventDefault() //禁止回车的默认换行
      }
    },
    // 监听输入框crtl+enter事件
    enterBtn(event) {
      event = event ? event : window.event ? window.event : ''
      var keyCode = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode
      if (event.keyCode == 13 && event.ctrlKey) {
        //ctrl+enter换行
        document.getElementById('haertop').style.paddingTop = '49px'
        document.getElementById('btn').style.height = '60px'
        document.getElementById('txt').value = this.searchContent
        // console.log(document.getElementById('txt').value)
        // document.getElementById('txt').value + '\n' // 获取textarea数据进行 换行

        // this.$refs.focusTextarea.focus()
        this.statefocus = true
        this.isArr = true
        document.getElementById('txt').value =
          document.getElementById('txt').value + '\r\n' + ''
        // document.getElementById('txt')[0].select()
        console.log(document.getElementById('txt').value + '\r\n' + '3333')
        console.log(document.getElementById('txt').value)

        // this.$refs.focusTextarea.focus()
      } else if (keyCode == 13) {
        event.preventDefault() //禁止回车的默认换行
      }
    },
    focusTxt() {
      this.focusBtn(1)
    }

    // change() {
    //   console.log(this.$refs.edit.innerHTML)
    // },
    // 去除输入框中所有空格
    // trim(v) {
    //   this[v] = this[v].replace(/\s+/g, '')
    //   console.log(this.searchContent)
    // }
    // clear() {
    //   this.arr = []
    //   this.searchContent = ''
    //   this.isArr = false
    //   document.getElementById('aaa').offsetHeight - 100
    //   document.getElementById('haertop').style.paddingTop = '73px'
    //   document.getElementById('btn').style.height = '44px'
    // },
    // 换行
    // lineFeed(e) {
    //   console.log(e)
    //   var e = e || window.event,
    //     ec = e.keyCode || e.which
    //   if (e.ctrlKey && 13 == ec) {
    //     if (this.browserType() == 'IE' || this.browserType() == 'Edge') {
    //       $('#chatroom_footer_text_textarea').append('<div></div>')
    //     } else if (this.browserType() == 'FF') {
    //       $('#chatroom_footer_text_textarea').append('<br/><br/>')
    //     } else {
    //       $('#chatroom_footer_text_textarea').append('<br/>')
    //     }
    //     if (this.$refs.cTextareaRef.innerHTML == '') {
    //       this.$refs.cTextareaRef.innerHTML =
    //         this.$refs.cTextareaRef.innerHTML + '<br/>'
    //     }
    //     document.execCommand('insertHTML', 'false', '<br/>')
    //   }
    // },
  },
  directives: {
    Focus: {
      update: function (el, { value }) {
        if (value) {
          // if(true)就聚焦
          el.focus()
        }
      }
    }
  },

  computed: {
    // searchFlag() {
    //   if (this.$route.query.searchFlag === 'false') {
    //     return false
    //   } else {
    //     return true
    //   }
    // }
  },
  watch: {},
  mounted() {
    // this.$refs.focusTextarea.focus()
  }
}
</script>
<style lang="less" scoped>
.header-search {
  // width: 1200px;
  // margin: 0 auto;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .clearfix {
    overflow: hidden;
    _zoom: 1;
  }
  .main {
    padding-bottom: 25px;
    height: 148px;
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .header-search-fl {
      padding: 80px 0 0 0px;
      margin-top: 9px;
      .imgs {
        width: 148px;
        height: 39px;
        margin-right: 207px;
      }
    }
    .header-search-fl1 {
      padding: 80px 0 0 0px;
      margin-top: 15px;
      .imgs2 {
        width: 179px;
        height: 35px;
      }
    }
    .header-search-fr {
      padding: 73px 0 0 0;
      .header-search-fr-btn {
        display: flex;
        i {
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #42444e;
          cursor: pointer;
        }
        .clickI {
          color: #377cf1;
        }
        .btnSearchi {
          font-size: 12px;
          border-radius: 2px 0px 0px 0px;
          border-right: none;
        }
        .btnSearchi2 {
          font-size: 12px;
          border-radius: 0px 2px 0px 0px;
        }
        .searchFlag {
          color: #377cf1;
        }
        .active a i {
          color: #377cf1;
        }
      }
      .w2 {
        position: absolute;
        top: 18px;
        right: 95px;
        cursor: pointer;
      }
      .w1 {
        left: calc(50% - 245px);
        position: absolute;
        max-height: 186px;
        width: 440px;
        top: 130px;
        // left: 37.15%;
        border: 2px solid #377cf1;
        border-top: none;
        background: #ffffff;
        z-index: 9999;
        p {
          cursor: pointer;
          padding: 0 8px;
          display: flex;
          color: #555555;
          justify-content: space-between;
          span {
            // background-color: pink;
            width: 95%;
            cursor: pointer;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .ivu-icon-md-close {
            line-height: 18px;
            cursor: pointer;
          }
        }
        p:hover {
          background-color: #57a3f3;
          color: #ffff;
        }
      }

      /deep/ .ivu-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #377cf1;
        border: 0;
        color: #ffffff;
        width: 80px;
        height: 36px;
        border-radius: 0px 2px 2px 0px;
        span {
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
  }
  .tabs {
    height: 36px;
    line-height: 36px;
    ul {
      width: 980px;
      display: flex;
      justify-content: left;
      margin-left: 220px;
      li {
        float: left;
        font-size: 18px;
        margin-right: 60px;
        color: #42444e;
        font-family: Source Han Sans CN;
        font-weight: 400;
        &:first-child {
          margin-left: 148px;
        }
        a {
          color: #42444e;
        }
        i:hover {
          color: #377cf1;
        }
      }
      /deep/ .active {
        i {
          color: #377cf1;
          font-weight: bold;
        }
      }
    }
  }
}
.huise {
  color: #c0c0c5;
}
.flex {
  display: flex;
}
.felx1 {
  flex: 1;
}
.fz16 {
  width: 32px;
  height: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.mr3 {
  margin-right: 3px;
}
.icon-sousuo {
  margin-right: 3px;
}
.seek {
  width: 32px;
  height: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.fr {
  float: right;
}
.w13 {
  cursor: pointer;
  width: 440px;
  height: 60px;
  // min-height: 36px;
  outline: none;
  max-height: 63px;
  // color: #ceced5;
  overflow-y: auto;
  border: 2px solid #377cf1;
  // background-color: transparent !important;
  padding: 0 28px 0 8px;
  p {
    cursor: pointer;
    // line-height: 19px;
    // display: flex;
    // justify-content: space-between;
    // color: #c1c1c1;
    // span {
    line-height: 18px;
    font-size: 12px;
    width: 90%;
    outline: none;
    // }
  }
  i {
    position: absolute;
    top: 11px;
    right: 96px;
    font-size: 20px;
    cursor: pointer;
  }
}
/deep/ .ivu-input {
  // color: #ceced5;
  width: 440px;
  height: 36px;
  font-size: 13px;
  border-radius: 0;
  border: 2px solid #377cf1;
  background-color: transparent !important;
  padding: 0 8px;
}
// /deep/ textarea.ivu-input {
//   resize: none;
// }
// /deep/.ivu-input-type-textarea > textarea {
//   // height: 36px;
//   // min-height: 36px;
//   // max-height: 50px;
::-webkit-scrollbar {
  /*滚动条整体粗细样式*/
  /*高宽分别对应横竖滚动条的尺寸*/
  width: 6px;
  height: 2px;
}

/*滚动条里面小方块*/
::-webkit-scrollbar-thumb {
  border-radius: 5px !important;
  // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
  /* 颜色 */
  background: #c1c1c1 !important;
  /* 线性渐变背景 */
  // background-image: #C1C1C1!important;
}

/*滚动条轨道*/
::-webkit-scrollbar-track {
  border-radius: 10px !important;
  // box-shadow: inset 0 0 5px rgb(0 0 0 / 20%) !important;
  // background: rgba(0,0,0,.1) !important;
}
// }
.w12 {
  color: #ceced5;
  position: absolute;
  right: 111px;
  font-size: 20px;
  top: 13px;
  cursor: pointer;
}
textarea {
  // color: #ceced5;
  color: #555555;
  width: 455px;
  min-height: 36px;
  max-height: 60px;
  height: 36px;
  font-size: 12px;
  resize: none;
  border: 2px solid #377cf1;
  background-color: transparent !important;
  padding: 0 8px;
  line-height: 20px;
  outline: none;
}
</style>
